<template>
	<div class="hint">
		<div class="hint-con">
			<a class="hint-ca" @click="closePop" />
			<div class="hint-cons">
				<h3 v-text="data.title" v-if='data.title'/>
				<p v-html="data.conText" />
			</div>
			<div class="hint-btn"><a v-text="data.btnText" @click="sub" /></div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['data'],
		data() {
			return {
				hintData: this.data
			}
		},
		mounted: function() {

		},
		methods: {
			//确定
			sub(){
				var self = this;
				self.$emit('closePop', self.hintData.type);
			},

			//关闭
			closePop(){
				var self = this;
				self.$emit('closePop');
			}
		}
	}
</script>

<style scoped>
.hint{ width: 100%; height: 100%; background: rgba(0, 0, 0, 0); display: flex; position: fixed; justify-content: center; align-items: center; top: 0; left: 0; z-index: 10;}
.hint-con{ width: 6.6rem; padding: 0.4rem 0.3rem 0.15rem 0.3rem; background-color: #FDF2FE; border: 0.06rem solid #FECC4C; border-radius: 0.16rem; position: relative;}
.hint-ca{ width: 0.4rem; height: 0.4rem; background: url(./img/close.png) no-repeat center; background-size: 0.18rem 0.18rem; position: absolute; top: 0; right: 0;}
.hint-cons h3{ line-height: 0.34rem; font-size: 0.26rem; margin-bottom: 0.3rem;}
.hint-cons p{ line-height: 0.32rem; font-size: 0.24rem; color: #545353;}
.hint-cons >>> span{ height: 0.15rem; display: block;}
.hint-btn{ height: 0.58rem; text-align: center; margin: 0.4rem auto 0.2rem auto;}
.hint-btn a{ height: 0.58rem; padding: 0 0.5rem; line-height: 0.58rem; font-size: 0.26rem; color: #FCFCF9; background: #ED5B0E; border-radius: 0.29rem; display: inline-block; margin: 0 auto;}
</style>